import {TimelineLite, TimelineMax} from "gsap";
import {DisplayObject} from "pixi.js";

export interface IShakeConfig {
    x: number;
    y: number;
    obj: DisplayObject;
    duration: number;
    Intensity?: number;
    hertz: number;
    angle?: number;
    reverseEase?: boolean;
    repeat?: number
    positionCb?: () => PIXI.Point;
}

export class ShakeEffect {
    private _stopShake: boolean = false;
    private _tl: TimelineLite;

    constructor() {

    }

    public stopShake(): void {
        this._stopShake = true;
        if (this._tl?.isActive()) {
            this._tl?.progress(100).pause().kill();
        }
    }

    public startShake(shakeDur: number, objectsToShake: PIXI.Container[]): TimelineLite {
        this._stopShake = false;
        if (this._tl?.isActive()) {
            this._tl?.pause().kill();
        }
        this._tl = new TimelineLite();
        objectsToShake.forEach((container, index) => {
            this._tl.add(
                this.shake({
                    x: 0.3,
                    y: 0.3,
                    obj: container,
                    repeat: 0,
                    duration: shakeDur,
                    Intensity: 30,
                    hertz: 70,
                }).play(), 0);
        });
        return this._tl;
    }

    private shake(config: IShakeConfig): TimelineMax {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;
        let t: boolean = true;
        const tl: TimelineMax = new TimelineMax({
            repeat: config.repeat,
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete: () => {
                if (config.obj.transform && config.obj.position) {
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                    //config.obj.angle = 0;
                } else {
                    //Logger.logDev("transform or Position undefined ", config.obj);
                }
                if (this._stopShake) {
                    return;
                }
                if (config.positionCb && config.obj) {
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }
            },
            onUpdate: () => {
                if (this._stopShake) {
                    return;
                }
                //config.obj.angle = 0;
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = 0.5;
                if (t) {
                    t = false;
                    return;
                }
                if (config.positionCb && config.obj) {
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }
                if (config.reverseEase)
                    et = 1 - et;
                if (config.Intensity) {
                    // if (config.angle != 0)
                    //     config.angle && (config.obj.angle = (Math.cos(lt * config.hertz) * et) * config.angle);
                    if (config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt * config.hertz) * (config.Intensity * et) * config.y;

                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * (config.Intensity * et)) * config.x;
                } else {
                    if (config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt * config.hertz) * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * et) * config.x;
                }
            }
        });
        !this._stopShake && tl.to(this, config.duration, {});
        return tl;
    }
}
